import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { fromEvent as observableFromEvent, Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, pairwise } from 'rxjs/operators';

import { WindowRefService } from './../../service/window/window.service';

@Injectable()
export class InfiniteScrollService {
    scrollSub$: Subscription;
    loadMore = new Subject<boolean>();
    loadMore$ = this.loadMore;

    constructor(
        private windowRef: WindowRefService,
        @Inject(DOCUMENT) private document: any
    ) {}

    createScrollWatcher(offset, offsetElements): void {
        const scroll$: Observable<Array<number>> = observableFromEvent(this.windowRef.nativeWindow, 'scroll', { passive: true }).pipe(
                map(() => {
                    let removeHeight = offset;

                    offsetElements.map(el => {
                        const element = this.document.querySelector(el);
                        if (element) removeHeight = removeHeight + element.offsetHeight;
                    });

                    const toBottom = this.getDistFromBottom(removeHeight);

                    return toBottom;
                }),
                pairwise(),
                filter(data => data[1] < data[0]),
                filter(data => data[1] === 0),
                distinctUntilChanged(),
                debounceTime(100));

        this.scrollSub$ = scroll$.subscribe(data => {
            this.loadMore.next(true);
        });
    }

    destroyScrollWatcher(): void {
        this.scrollSub$.unsubscribe();
    }

    private getDistFromBottom(deduct: number): number {
        const scrollPosition = this.windowRef.nativeWindow.pageYOffset;
        const windowSize = this.windowRef.nativeWindow.innerHeight;
        const bodyHeight = this.document.body.offsetHeight;

        return Math.max((bodyHeight - deduct) - (scrollPosition + windowSize), 0);
    }
}
